// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GameBoard_wrapper__3wbJ_"};